// Libraries
import React from 'react';
import PropTypes from 'prop-types';

const Checkers = ({
    checkerList,
    roleStatus,
    setRoleStatus,
    numberOfRecord,
    setIsResetPage,
    isResetPage,
}) => (
    <div className="checker clearfix">
        <div className="checkerTitle">
            <p>
                {roleStatus} <span>({numberOfRecord})</span>
            </p>
        </div>
        <div className="checkerProcess">
            <ul>
                {checkerList.map(checker => (
                    <li
                        key={checker}
                        className={checker === roleStatus ? 'selected' : ''}
                        onClick={() => {
                            setRoleStatus && setRoleStatus(checker);
                            setIsResetPage && setIsResetPage(!isResetPage);
                        }}
                    >
                        {checker}
                    </li>
                ))}
            </ul>
        </div>
    </div>
);

Checkers.propTypes = {
    checkerList: PropTypes.array,
    numberOfRecord: PropTypes.number,
    roleStatus: PropTypes.string,
    setRoleStatus: PropTypes.func,
    setIsResetPage: PropTypes.func,
    isResetPage: PropTypes.bool,
};

export default Checkers;
